import React, { useEffect, useState } from "react";
import { Alert, Button, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import { applyUpdate, isUpdateAvailable, onUpdateAvailable } from "../../serviceWorkerRegistration";

// "New version available - Reload", shown after a deploy while this page still runs the previous
// version. It stays until the user reloads (no auto-hide, no auto-reload), so nobody loses
// unsaved work; the user picks the moment.
export default function UpdateAvailableNotice() {
	const [t] = useTranslation();
	const [open, setOpen] = useState(isUpdateAvailable);

	useEffect(() => onUpdateAvailable(() => setOpen(true)), []);

	return (
		<Snackbar open={open} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
			<Alert
				severity="info"
				variant="filled"
				action={
					<Button color="inherit" size="small" onClick={applyUpdate}>
						{t("Reload")}
					</Button>
				}
			>
				{t("A new version of the app is available")}
			</Alert>
		</Snackbar>
	);
}
